"use client"

import { useRemoveFromCart } from "@/hooks/use-cart-mutations"
import { useRouter } from "next/navigation"
import { Loader2, Trash } from "lucide-react"
import { cn } from "@/components/common"
import { Button } from "@/components/ui/button"
import { showSuccess, showError } from "@/lib/toast"
import { useTranslations } from "next-intl"

const DeleteButton = ({
  id,
  children,
  className,
}: {
  id: string
  children?: React.ReactNode
  className?: string
}) => {
  const router = useRouter()
  const removeFromCart = useRemoveFromCart()
  const t = useTranslations('cart')

  const handleDelete = (id: string) => {
    removeFromCart.mutate(id, {
      onSuccess: () => {
        router.refresh()
        showSuccess(t('itemRemoved'), t('itemRemovedDesc'))
      },
      onError: (err) => {
        console.error('Failed to delete item:', err)
        showError(t('error'), err.message || t('removeFailed'))
      },
    })
  }

  return (
    <div
      className={cn(
        "flex items-center justify-between text-small-regular",
        className
      )}
    >
      <Button
        variant="ghost"
        size="sm"
        className="flex gap-x-1 text-ui-fg-subtle hover:text-ui-fg-base h-auto p-0"
        onClick={() => handleDelete(id)}
        disabled={removeFromCart.isPending}
      >
        {removeFromCart.isPending ? <Loader2 className="animate-spin h-4 w-4" /> : <Trash className="h-4 w-4" />}
        <span>{children}</span>
      </Button>
    </div>
  )
}

export default DeleteButton
